class MobileVariantsTable extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.variantTables = this.querySelectorAll('[data-variant-table]');
    this.currentVariant = null;
  }

  connectedCallback() {
    if (this.select && this.variantTables.length > 0) {
      this.select.addEventListener('change', this.onSelectChange.bind(this));
      this.currentVariant = this.select.value;
      this.updateVariantDisplay();
    }
  }

  onSelectChange(event) {
    this.currentVariant = event.target.value;
    this.updateVariantDisplay();
  }

  updateVariantDisplay() {
    this.variantTables.forEach(table => {
      const tableId = table.dataset.variantTableId;
      if (this.currentVariant === tableId) {
        table.style.display = 'block';
      } else {
        table.style.display = 'none';
      }
    });
  }
}

customElements.define('mobile-variants-table', MobileVariantsTable); 